var _rect, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDiscountIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56,
    rx: 28,
    fill: "#183887"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.9889 30.6604L18.4689 29.1404C17.8489 28.5204 17.8489 27.5004 18.4689 26.8804L19.9889 25.3604C20.2489 25.1004 20.4589 24.5904 20.4589 24.2304V22.0804C20.4589 21.2004 21.1789 20.4804 22.0589 20.4804H24.2089C24.5689 20.4804 25.0789 20.2704 25.3389 20.0104L26.8589 18.4904C27.4789 17.8704 28.4989 17.8704 29.1189 18.4904L30.6389 20.0104C30.8989 20.2704 31.4089 20.4804 31.7689 20.4804H33.9189C34.7989 20.4804 35.5189 21.2004 35.5189 22.0804V24.2304C35.5189 24.5904 35.7289 25.1004 35.9889 25.3604L37.5089 26.8804C38.1289 27.5004 38.1289 28.5204 37.5089 29.1404L35.9889 30.6604C35.7289 30.9204 35.5189 31.4304 35.5189 31.7904V33.9403C35.5189 34.8203 34.7989 35.5404 33.9189 35.5404H31.7689C31.4089 35.5404 30.8989 35.7504 30.6389 36.0104L29.1189 37.5304C28.4989 38.1504 27.4789 38.1504 26.8589 37.5304L25.3389 36.0104C25.0789 35.7504 24.5689 35.5404 24.2089 35.5404H22.0589C21.1789 35.5404 20.4589 34.8203 20.4589 33.9403V31.7904C20.4589 31.4204 20.2489 30.9104 19.9889 30.6604Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25 31L31 25",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30.4945 30.5H30.5035",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M25.4945 25.5H25.5035",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiscountIcon);
export default __webpack_public_path__ + "static/media/DiscountIcon.3e11d2b16d7b3165bcc76ed3f14cc774.svg";
export { ForwardRef as ReactComponent };